<template>
  <ion-page>
    <master-layout pageTitle="سرویس های قابل ارائه توسط شما">
      <ion-card>
        <ion-card-content>
          <div>
            <label>سرویس</label>
            <ali-ajax-select :on-change="changeService" route="app/GetServiceForSelect" title="خدمات" itemTitle="title" name="service_id" desc="جستجو خدمت" itemId="_id"></ali-ajax-select>
          </div>
          <button @click="addService" class="btn btn-success">افزودن سرویس</button>
        </ion-card-content>
      </ion-card>
      <ion-card-content>
        <h2><i class="far fa-tools"></i>&nbsp;خدمات شما :</h2>
      <AjaxForm route="autoServiceServices/Submit">
      <ion-card v-for="(item,index) in services" :key="index">
        <input type="hidden" name="id[]" :value="item._id" readonly>
        <ion-card-content class="position_relative">
          <div>{{item.title}}</div>
          <button type="button" @click="removeService(index)" class="btn del_btn"><i class="far fa-times text-danger"></i></button>
        </ion-card-content>
      </ion-card>
      <button type="submit" class="btn btn-info btn-block">ثبت خدمات</button>
      </AjaxForm>
      </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
// import {showSystemNoti} from '@/shared/helper'
import {IonPage,IonCard,IonCardContent} from '@ionic/vue';
import AliAjaxSelect from "@/components/aliAjaxSelect";
import {showSystemNoti} from "@/shared/helper";
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  name: "Addcustomer",
  components: {
    AjaxForm,
    AliAjaxSelect,
    IonPage,IonCard,IonCardContent
  },
  data()
  {
    return {
      id:null,
      servicesLoaded: false,
      services:[{_id : 1,title : 'salam'},{_id : 1,title : 'salam2'}],
      error:null,
      service : null,
      service_ids : []
    }
  },
  async created()
  {

  },
  methods: {
    ...mapActions("app", {
      getServicesOfAuto : 'getServicesOfAuto'
    }),
    changeService : async function(c)
    {
      if (c && c.length)
        this.service = c[0];
      else
        this.service = null;
    },
    async removeService(index)
    {
      this.services.splice(index,1);
    },
    addService()
    {
      const service = this.service;
      if (service)
      {
        const services = this.services;
        const result = services.find( ({ _id }) => _id === service._id );
        if (result)
          return showSystemNoti('danger','سرویس انتخابی در لیست سرویس های شما موجود است.');
        this.services.push(service);
      }
      else
        return showSystemNoti('danger','ابتدا سرویس را انتخاب کنید.');
    }
  },
  async mounted()
  {
    const services = await this.getServicesOfAuto();
    if (services.ok)
    {
      this.services = services.services;
      // this.services.concat()
    }
    else
      this.services = [];
  },
}

</script>

<style scoped>
.del_btn
{
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
}
</style>